export const ChunkTagIDs = {
    minHeight: "#dve_min_height",
    maxHeight: "#dve_max_height",
    heightMap: "#dve_height_map",
    dirtyMap: "#dve_dirty_map",
    voxelIDSegment: "#dve_voxel_id",
    voxelLightSegment: "#dve_voxel_light",
    voxelStateSegment: "#dve_voxel_state",
    voxelSecondaryIDSegment: "#dve_voxel_secondary_id",
};
